import styled, { css } from "styled-components";
import { staffLines } from "../../../common/styles";

export const PlayWrapper = styled.div`
    height: calc(100vh - 50px);
    padding-top: 50px;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ChangeOrientation = styled.h3`
    text-align: center;
    font-variant: normal;
    font-weight: 400;
    padding: 0 20px 20px;
`;

export const KeyPage = styled.div`
    background-color: ${p => p.theme.c.dark};
    padding: 0 12px;
    padding-top: 50px;
    background-size: 100% 120px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    ${staffLines}

    input {
        font-size: 50px;
        width: 131px;
        margin: auto;
        display: block;
    }

    label,
    [class^="Validation"] {
        text-align: center;
    }

    h1 {
        color: ${p => p.theme.c.boost};
        text-align: center;
        margin-top: 0;
    }
`;

export const KeyPageWrapper = styled.div`
    background: ${p => p.theme.mode === "dark" ? p.theme.c.snow : p.theme.c.light};
    border-radius: 20px;
    border: ${p => p.theme.c.info} 10px solid;
    padding: 20px;
    min-width: 250px;
    max-width: 300px;
    ${p => p.theme.sm.min(css`
        max-width: none;
        width: 486px;
    `)}
    box-sizing: border-box;
    text-align: center;
`;

export const LogoCropper = styled.div`
    width: 64px;
    overflow: hidden;
    margin: auto;
    svg {
        margin-right: 4px;
        width: 376px;
        height: 80px;
        fill: ${p => p.theme.c.boost};
        margin-top: 12px;
    }
`;

export const Privacy = styled.p`
    font-size: 12px;
`;